import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
const benefits = ['Complete class structure', 'Sequencing already planned', 'Teaching cues included', 'Modifications included'];
export function SolutionSection() {
  return <section className="w-full bg-cream py-9 sm:py-12" aria-labelledby="solution-heading" data-id="element-171" data-mp="3ja7g9u6ft9ta">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-172" data-mp="14kx53txytk4">
        <div className="mx-auto max-w-2xl text-center" data-id="element-173" data-mp="131cz255zyd2">
          <div className="flex justify-center" data-id="element-174" data-mp="3t8wy5myc2u9j">
            <SectionLabel data-id="element-175" data-mp="3t8526b0tquiq">The difference</SectionLabel>
          </div>
          <h2 id="solution-heading" className="mt-3 font-serif text-[1.4rem] font-semibold uppercase leading-[1.1] text-ink sm:text-4xl" data-id="element-176" data-mp="atcnj7jct5sx">
            You don’t need more yoga inspiration.
            <span className="block text-forest" data-id="element-177" data-mp="kstppezed1k5">You need classes that are ready to teach.</span>
          </h2>
          <p className="mx-auto mt-3 max-w-lg text-[0.9rem] leading-snug text-muted sm:text-base" data-id="element-178" data-mp="fre49ltb4t18">
            Inspiration still leaves you responsible for building the class. Yoga Teacher System™
            gives you the structure that comes after it.
          </p>
        </div>

        <ul className="mx-auto mt-5 grid max-w-2xl grid-cols-2 gap-2" data-id="element-179" data-mp="3f9r0on8cqhdh">
          {benefits.map(benefit => <li key={benefit} className="flex h-full items-center justify-center gap-2 rounded-xl border border-sandDark bg-ivory px-3 py-3 text-center" data-id="element-180" data-mp="3k8al2j7arl3q">
              <CheckIcon className="h-3 w-3 shrink-0 text-forest" aria-hidden="true" data-id="element-181" data-mp="3u6qamhqoemb4" />
              <span className="text-[0.78rem] font-medium leading-snug text-ink sm:text-[0.88rem]" data-id="element-182" data-mp="2uf88246g55q">
                {benefit}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-5 max-w-xl text-center font-serif text-[1rem] font-semibold uppercase leading-tight text-ink sm:text-2xl" data-id="element-183" data-mp="bvwk18ajxkom">
          The class is already structured.
          <span className="block text-forest" data-id="element-184" data-mp="2cxuran0f841z">You bring the teaching.</span>
        </p>
      </div>
    </section>;
}